import { EditGuesser } from '@api-platform/admin';
import { useRecordContext, EditBase } from 'react-admin';
import { Box, Typography } from '@mui/material';

import VideoPlayer from "./VideoPlayer";

// Create a wrapper component that gets the video ID from context
const BrightcoveVideoPlayer = () => {
    const record = useRecordContext();
    if (!record || !record.brightcoveVideoId) return null;
    return (
        <Box sx={{ m: 2 }}>
            <VideoPlayer 
                brightcoveVideoId={record?.brightcoveVideoId} 
                tracks={record.tracks}
                courseTitle={record?.courseTitle}
                videoTitle={record?.title}
            />
        </Box>
    );
};

const VideoEdit = () => (
    <EditBase emptyWhileLoading>
        <BrightcoveVideoPlayer />
    </EditBase>
);

export default VideoEdit;
